export enum ConditionsOperator {
    EQUALS = "equals",
    IN = "in",
    NOTEMPTY = "notempty",
}
